// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"84f67b01","239":"8759afd3","508":"445d96bc","776":"00dc7d7c"}[chunkId] + ".chunk.js";
};